import React from "react";
import { PRIORITY_TO_GRADE } from "@sscs/utils";
import { useNavigate } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { filterByLink, resetFilter } from "../../../store/issuesSlice";
import { Issues } from "../../../ui";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
import styles from "./issues.module.scss";
const IssuesContainer = ({ issues, policyStatistics, }) => {
    const navigate = useNavigate();
    const dispatch = useReportDispatch();
    const totalIssues = Object.values(issues.priority_count).reduce((acc, count) => acc + count, 0);
    return (React.createElement(Issues.Panel, { issues: issues, helperText: React.createElement(LinkToReportTab, { id: "All issues", to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, color: "link", onClick: () => dispatch(resetFilter()) },
            "All issues (",
            totalIssues.toLocaleString(),
            ")") },
        React.createElement(Issues.TopIssuesList, { issues: issues, policyStatistics: policyStatistics, gradeIconWrapper: (issue, children) => (React.createElement(LinkToReportTab, { underline: "hover", id: `issue-link-${issue.id}`, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, className: styles.priority, onClick: () => dispatch(filterByLink({
                    issue: { operation: "is", values: [issue.id] },
                })) }, children)) }),
        React.createElement(Issues.PriorityBars, { issues: issues, onPriorityLabelClick: (priorityNumber) => {
                dispatch(filterByLink({
                    grade: {
                        operation: "is",
                        values: [PRIORITY_TO_GRADE[priorityNumber]],
                    },
                }));
                navigate(REPORT_PAGES_ROUTES.ISSUES_ROUTE);
            } })));
};
export default IssuesContainer;
//# sourceMappingURL=Issues.js.map